export default __webpack_public_path__ + "static/media/PlayersManagementarImageOne.a0cad507.png";